import React from 'react';
import { CSVLink } from 'react-csv';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Grid } from '@shared/Grid';
import Footer from '@shared/Footer';
import Header from '@components/Header';

export default function UserProfile() {
  return (
    <div>
      <Helmet>
        <title>Screen Console - Page not found.</title>
      </Helmet>
      <PageContainer gutter>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>
        <MainContainer>
          <ErrorContainer>
            <div>Page not found.</div>
            <br/>
            <br/>
            <div>
              <a href='/'>
                <button>Home</button>
              </a>
            </div>
          </ErrorContainer>
          <Footer />
        </MainContainer>
      </PageContainer>
    </div>
  );
}

const SpinnerContainer = styled.div`
  height: 80vh;
`;

const LogoutContainer = styled.div`
  max-width: 300px;
  margin: 10px auto;
  text-align: center;
`;

const HeaderWrapper = styled.div`
  justify-content: flex-start;
`;

const PageContainer = styled(Grid)`
  max-width: 1440px;
  width: 100vw;
`;

const MainContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1080px;
`;

const ErrorContainer = styled.div`
  text-align: center;
  height: 40vh;
`;
